import { HSN_TAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "HSN Code Id",
    field: "hsnCodeId",
    flex: 1,
    hide: true,
  },
  {
    headerName: "HSN Code",
    field: "hsnCode",
    flex: 1,
  },
  {
    headerName: "Description",
    field: "description",
    flex: 1,
  },
  {
    headerName: "GST %",
    field: "gstPercent",
    flex: 1,
  },
  {
    headerName: "Company",
    field: "company",
    flex: 1,
  },
  {
    headerName: "Remarks",
    field: "remarks",
    flex: 1,
  },
];

export const transformPayload = (hsn) => {
  return {
    hsnCodeId: hsn?.hsnCodeId || undefined,
    hsnCode: hsn?.hsnCode || "",
    description: hsn?.description || "",
    gstPercent: hsn?.gst?.id || 0,
    company: hsn?.company || "",
    deleted: hsn?.deleted || false,
    remarks: hsn?.remarks || "",
  };
};

export const initial_state_hsn = {
  type: HSN_TAB,
  label: "HSN Master",
  allowMultipleTabs: false,
};
